import { useMemo } from 'react';
import { useSingletonWindowSize } from './useSingletonWindowSize';
/**
 * Used to retrieve the computed style of an HTMLElement
 * when window size changes
 * @param htmlElement Element to track
 * @param property the css style to retrieve from htmlElement
 * @returns The computed style based on the given property when the width changes.
 */
export var useComputedStyle = function (htmlElement, propertyValue) {
    var width = useSingletonWindowSize().width;
    var computedPropertyValue = useMemo(function () {
        if (!width || !htmlElement) {
            return undefined;
        }
        return getComputedStyle(htmlElement).getPropertyValue(propertyValue);
    }, [width, htmlElement, propertyValue]);
    return computedPropertyValue;
};
//# sourceMappingURL=useComputedStyle.js.map